import Select from 'Components/Select';
import Label from 'Components/Label';
import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';

export const userOptions = [...eFormGTB.users];

const UserSelect = ({
	onChange,
	value,
	title = __('Select a user', 'ipt_fsqm'),
	...selectProps
}) => (
	<Label title={title}>
		<Select
			onChange={onChange}
			options={userOptions}
			value={value}
			{...selectProps}
		/>
	</Label>
);
UserSelect.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.objectOf(PropTypes.string),
};

UserSelect.defaultProps = {
	value: null,
};

export default UserSelect;
